

export const getPageCount = (count) => {
    var pageCount = parseInt(count/ 10)
    return count%10 > 0 ? pageCount + 1 : pageCount
}